import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ResolveEnd, Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { EmailService } from 'src/app/core/service/forgotPassword/email.service';

@Component({
  selector: 'app-forget-password',
  templateUrl: './forget-password.component.html',
  styleUrls: ['./forget-password.component.css'],
})
export class ForgetPasswordComponent implements OnInit {
  emailForm: FormGroup;
  submitted = false;
  emailRegex = '[a-z0-9._%+-]+@[a-z0-9.-]+.[a-z]{2,3}$';
  disableBtn: boolean = false;
  button: string = 'Send Verification Link';
  resend: boolean = false;
  constructor(
    private fb: FormBuilder,
    private emailService: EmailService,
    private router: Router,
    private messageService: MessageService
  ) {}

  ngOnInit(): void {
    this.disableBtn = false;
    this.formInit();
  }
  formInit(): void {
    this.emailForm = this.fb.group({
      email: ['', [Validators.required, Validators.pattern(this.emailRegex)]],
      appType: ['user'],
      resend: [this.resend],
    });
  }
  get f() {
    return this.emailForm.controls;
  }
  // email Method
  onSend(): void {
    this.submitted = true;
    // stop here if form is invalid
    if (this.emailForm.invalid) {
      return;
    }
    this.resend = false;
    this.disableBtn = true;
    this.emailForm.value.resend = false;
    this.emailService.forgot(this.emailForm.value).subscribe(
      (res) => {
        console.log(this.emailForm.value);
        console.log(res);
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: res.message,
        });
      },
      (error) => {
        if (error.code === 429) {
          this.disableBtn = true;
          this.button = 'Resend';
          this.resend = true;
          this.emailForm.value.resend = true;
          this.resended();
        } else {
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: error.message,
          });
        }
      }
    );

    setTimeout(() => {
      this.disableBtn = false;
    }, 5000);
  }
  onReload() {
    window.location.reload();
  }
  resended() {
    this.emailService.forgot(this.emailForm.value).subscribe((res) => {
      this.messageService.add({
        severity: 'success',
        summary: 'Success',
        detail: res.message,
      });
    });
  }
}
